import { MatIconRegistry } from '@angular/material/icon';
import { inject, provideAppInitializer } from '@angular/core';

/**
 * Inizializzazione delle z-icons allo startup dell'applicazione
 */
function initializeMatIcon(matIconRegistry: MatIconRegistry) {
  return (): void => {
    matIconRegistry.registerFontClassAlias('z-icons', 'z-icons');
    matIconRegistry.setDefaultFontSetClass('z-icons');
  };
}

export const matIconInitializerProvider = provideAppInitializer(() => {
  const initializerFn = initializeMatIcon(inject(MatIconRegistry));
  return initializerFn();
});
